import { useEffect, useState } from 'react';
import styles from './PollWorldCup.module.css';

const PollWorldCup = (props) => {
  const { idPoll, isPreview = false } = props;
  const [isClient, setIsClient] = useState(false);

  if (isPreview) {
    return (
      <div className={styles.pollContainerPreview}>
        <p>Encuesta del Mundial</p>
        <p>ID de la encuesta: {idPoll || 'No se ha proporcionado un ID'}</p>
      </div>
    );
  }
  if (!idPoll) {
    return null;
  }

  

  useEffect(() => {
    setIsClient(true);
  }, []);

  
  if (!isClient) return null; 

  return (
    <div
      className="poll-container"
      data-stage="staging"
      id={`poll-container-${idPoll}`}
      data-id={idPoll}
      data-show-share="false"
      data-show-info="false"
      data-stats=""
    />
  );
};

export default PollWorldCup;
